import { OperationKeys } from '@decaf-ts/db-decorators';
import { canActivate, canActivateChild, plaOnly } from './guards/auth.guard';
import { EPIRoles, Namespaces, PLARoles } from './utils/constants';
import { RouteLike } from './utils/types';
export const routes: RouteLike[] = [
  {
    path: '',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },

  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },

  {
    path: 'dashboard',
    canActivate: [canActivate],
    loadComponent: () => import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
    menu: {
      icon: 'ti-layout-dashboard',
    },
  },

  {
    path: 'astratrace',
    canActivate: [canActivate],
    loadComponent: () => import('./pages/astratrace/astratrace.page').then((m) => m.AstraTracePage),
    menu: {
      icon: 'ti-brand-databricks',
    },
  },

  {
    path: '',
    canActivateChild: [canActivateChild],
    namespaces: [Namespaces.EPI, Namespaces.PLA],
    children: [
      {
        path: 'products',
        loadComponent: () => import('./pages/products/products.page').then((m) => m.ProductsPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
        menu: {
          activeWhen: ['products', 'batches'],
          icon: 'ti-package',
        },
      },
      {
        path: 'products/:operation',
        loadComponent: () => import('./pages/products/products.page').then((m) => m.ProductsPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'products/:operation/:modelId',
        loadComponent: () => import('./pages/products/products.page').then((m) => m.ProductsPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'batches',
        loadComponent: () => import('./pages/batches/batches.page').then((m) => m.BatchesPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'batches/:operation',
        loadComponent: () => import('./pages/batches/batches.page').then((m) => m.BatchesPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'batches/:operation/:modelId',
        loadComponent: () => import('./pages/batches/batches.page').then((m) => m.BatchesPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },

      {
        path: 'leaflets',
        loadComponent: () => import('./pages/leaflets/leaflets.page').then((m) => m.LeafletsPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
        blockOperations: [], // allow all operations
        menu: {
          icon: 'ti-file-barcode',
        },
      },
      {
        path: 'leaflets/:operation',
        loadComponent: () => import('./pages/leaflets/leaflets.page').then((m) => m.LeafletsPage),
        blockOperations: [OperationKeys.UPDATE], // allow all operations
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'leaflets/:operation/:modelId',
        blockOperations: [OperationKeys.UPDATE], // allow all operations
        loadComponent: () => import('./pages/leaflets/leaflets.page').then((m) => m.LeafletsPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, EPIRoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'audit',
        loadComponent: () => import('./pages/audit/audit.page').then((m) => m.AuditPage),
        roles: [EPIRoles.ADMIN_ROLE, EPIRoles.READER_ROLE, PLARoles.READER_ROLE],
        menu: {
          icon: 'ti-file-search',
        },
      },
      {
        path: 'tasks',
        loadComponent: () => import('./pages/tasks/tasks.page').then((m) => m.TasksPage),
        namespaces: [Namespaces.PLA],
        roles: [PLARoles.ADMIN_ROLE, PLARoles.WRITER_ROLE, PLARoles.READER_ROLE],
        menu: {
          icon: 'ti-subtask',
        },
      },
      {
        path: 'tasks/:operation/',
        loadComponent: () => import('./pages/tasks/tasks.page').then((m) => m.TasksPage),
        roles: [PLARoles.ADMIN_ROLE, PLARoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'tasks/:operation/:modelId',
        loadComponent: () => import('./pages/tasks/tasks.page').then((m) => m.TasksPage),
        roles: [PLARoles.ADMIN_ROLE, PLARoles.WRITER_ROLE, PLARoles.READER_ROLE],
      },
      {
        path: 'account',
        loadComponent: () => import('./pages/account/account.page').then((m) => m.AccountPage),
        roles: [],
        menu: {
          icon: 'ti-user',
        },
      },
    ],
  },
  {
    path: 'admin',
    namespaces: [Namespaces.PLA],
    children: [
      {
        path: 'enrollments',
        canActivate: [canActivateChild],
        roles: [PLARoles.ADMIN_ROLE, PLARoles.READER_ROLE, PLARoles.WRITER_ROLE],
        menu: { icon: 'ti-stack-2' },
        loadComponent: () => import('./pages/admin/enrollments/enrollments.page').then((m) => m.EnrollmentsPage),
      },
      {
        path: 'enrollments/:operation',
        canActivate: [canActivateChild],
        roles: [PLARoles.ADMIN_ROLE, PLARoles.READER_ROLE],
        loadComponent: () => import('./pages/admin/enrollments/enrollments.page').then((m) => m.EnrollmentsPage),
      },
      {
        path: 'enrollments/:operation/:modelId',
        canActivate: [canActivateChild],
        blockOperations: [],
        roles: [PLARoles.ADMIN_ROLE, PLARoles.READER_ROLE],
        loadComponent: () => import('./pages/admin/enrollments/enrollments.page').then((m) => m.EnrollmentsPage),
      },
      {
        path: 'accounts',
        canActivate: [canActivateChild],
        roles: [PLARoles.ADMIN_ROLE, PLARoles.READER_ROLE, PLARoles.WRITER_ROLE],
        menu: { icon: 'ti-user-check' },
        loadComponent: () => import('./pages/admin/accounts/accounts.page').then((m) => m.AccountsPage),
      },
      {
        path: 'accounts/:operation',
        canActivate: [canActivateChild],
        blockOperations: [OperationKeys.CREATE, OperationKeys.DELETE], // only allow read and update
        roles: [PLARoles.ADMIN_ROLE, PLARoles.READER_ROLE],
        loadComponent: () => import('./pages/admin/accounts/accounts.page').then((m) => m.AccountsPage),
      },
      {
        path: 'accounts/:operation/:modelId',
        canActivate: [canActivateChild],
        blockOperations: [OperationKeys.CREATE, OperationKeys.DELETE], // only allow read and update
        roles: [PLARoles.ADMIN_ROLE, PLARoles.READER_ROLE],
        loadComponent: () => import('./pages/admin/accounts/accounts.page').then((m) => m.AccountsPage),
      },
    ],
  },
  {
    path: 'token',
    canActivate: [plaOnly],
    namespaces: [Namespaces.PLA],
    loadComponent: () => import('./pages/admin/enroll-token/enroll-token.page').then((m) => m.EnrollTokenPage),
  },
  {
    path: 'token/enroll',
    canActivate: [plaOnly],
    namespaces: [Namespaces.PLA],
    loadComponent: () => import('./pages/admin/enroll/enroll.page').then((m) => m.EnrollPage),
  },
  {
    path: 'error',
    loadComponent: () => import('./pages/error/error.page').then((m) => m.ErrorPage),
  },
  {
    path: 'logout',
    data: { loggedOut: true },
    menu: {
      icon: 'ti-logout-2',
      color: 'danger',
    },
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];
